<template>
  <div>
    <Hero />
  </div>
</template>

<script>
import Hero from "../components/Hero.vue"
import Services from "../components/Services.vue"
import Content from "../components/Content.vue"

export default {
  name: "Home",
  components: { Hero, Services, Content },
  setup() {
    return {}
  },
}
</script>

<style scoped></style>
